import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface StatsCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}
export function StatsCard({
  icon,
  label,
  value,
  trend
}: StatsCardProps) {
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-129">
      <div className="flex items-start justify-between" data-id="element-130">
        <div className="flex-1" data-id="element-131">
          <div className="text-sm font-medium text-gray-600 mb-1" data-id="element-132">{label}</div>
          <div className="text-3xl font-bold text-gray-900" data-id="element-133">
            {value.toLocaleString()}
          </div>
          {trend && <div className={`flex items-center gap-1 mt-2 text-sm ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-134">
              {trend.isPositive ? <TrendingUpIcon size={16} data-id="element-135" /> : <TrendingDownIcon size={16} data-id="element-136" />}
              <span data-id="element-137">{Math.abs(trend.value)}%</span>
            </div>}
        </div>
        <div className="w-12 h-12 bg-[#1B5E20] bg-opacity-10 rounded-lg flex items-center justify-center text-[#1B5E20]" data-id="element-138">
          {icon}
        </div>
      </div>
    </div>;
}